import React from 'react';
import { Modal as BSModal, Sizes } from 'react-bootstrap';
import { Form } from '../../Form/Form';
import { handleRenderProp, RenderProp } from '../../../utils/handleRenderProp';
import * as Yup from "yup";

export interface ModalProps {
    show?: boolean;
    title: JSX.Element | RenderProp | string;
    size?: Sizes;
    onHide?: () => void;
    buttons: JSX.Element | RenderProp;
    excludeCloseButton?: boolean;
    animation?: boolean;
    onSubmit?: (e: React.FormEvent<HTMLFormElement>) => void;
    validationSchema?: Yup.Schema<any>;
    showErrors?: boolean;
    values?: any;
    onEntered?: (node: HTMLElement) => void;
}

export const Modal: React.FC<ModalProps> = (props) => {
    const includeCloseButton = !props.excludeCloseButton;
    const emptyFn = () => {};

    //const buttonContent = handleRenderProp(props.buttons);
    const titleContent = handleRenderProp(props.title);

    let modal = (
        <BSModal
          show={props.show}
          bsSize={props.size}
          backdrop="static"
          onHide={props.onHide || emptyFn}
          aria-labelledby="ts-modal-title"
          animation={props.animation !== undefined ? props.animation : true}
          >
            <BSModal.Header closeButton={includeCloseButton}>
            <BSModal.Title id="ts-modal-title">
                {titleContent}
            </BSModal.Title>
            </BSModal.Header>
            <BSModal.Body>
                {props.children}
            </BSModal.Body>
            <BSModal.Footer>
                {
                    !props.onSubmit ? handleRenderProp(props.buttons) : undefined
                }   
            </BSModal.Footer>
        </BSModal>
    )

    if(props.onSubmit){
        modal = (
            <BSModal
                show={props.show}
                bsSize={props.size}
                backdrop="static"
                onHide={props.onHide || emptyFn}
                aria-labelledby="ts-modal-title"
                animation={props.animation !== undefined ? props.animation : true}
                onEntered={props.onEntered}
                >
                <Form onSubmit={props.onSubmit}
                    validationSchema={props.validationSchema}
                    showErrors={props.showErrors}
                    values={props.values}
                >
                    {(formState) => (
                        <>
                            <BSModal.Header closeButton={includeCloseButton}>
                            <BSModal.Title id="ts-modal-title">
                                {titleContent}
                            </BSModal.Title>
                            </BSModal.Header>
                            <BSModal.Body>
                                {props.children}
                            </BSModal.Body>
                            <BSModal.Footer>
                                {handleRenderProp(props.buttons, formState)}
                            </BSModal.Footer>
                        </>
                    )}
                </Form>
            </BSModal>
        )
    }

    return modal;
}

(Modal as any).displayName = "Modal";